module.exports = __webpack_public_path__ + "static/resume-e3b9e54481b4935695184e2143bc2441.pdf";